function breadcrumb(state = [], action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

export default breadcrumb;



// WEBPACK FOOTER //
// ./assets/pois/reducers/breadcrumb.js